export const getPublishButtonDisabledReason = ({
	title,
	isPublishingContent,
	userOffline = false,
	forceDisabled = false,
}: {
	title: any;
	isPublishingContent: any;
	userOffline?: boolean | undefined;
	forceDisabled?: boolean | undefined;
}):
	| ''
	| 'editor.buttons.disable.by.empty.title.tooltip'
	| 'editor.buttons.disable.by.saving.tooltip' => {
	if (userOffline || forceDisabled) {
		// no tooltip for publish button when disabled due to internet lost, banner will be shown indicating lost connection
		// no tooltip for publish button when editor is force disabled, this happens when page is converted to blog or converted between live and non live page
		return '';
	} else if (!title) {
		return 'editor.buttons.disable.by.empty.title.tooltip';
	} else if (isPublishingContent) {
		return 'editor.buttons.disable.by.saving.tooltip';
	}

	return '';
};
